import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DID_STATUS } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-did-status',
  template: '<div [class]="statusClass">{{status}}</div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DidStatusComponent implements OnInit {
  @Input('status') status: DID_STATUS;
  public statusClass: string;
  private classMapping = {
    [DID_STATUS.CREATED]: 'vox-chip vox-chip_aquamarine',
    [DID_STATUS.TEMPORARY_ACTIVE]: 'vox-chip vox-chip_royal-blue-text',
    [DID_STATUS.ACTIVE]: 'vox-chip vox-chip_royal-blue',
    [DID_STATUS.DISABLED]: 'vox-chip vox-chip_dark-grey',
    [DID_STATUS.DELETED]: 'vox-chip vox-chip_bright-crimson',
    [DID_STATUS.WAITING_VERIFICATION_DATA]: 'vox-chip vox-chip_purple-text',
    [DID_STATUS.WAITING_PROVIDER_VALIDATION]: 'vox-chip vox-chip_purple',
    [DID_STATUS.VERIFICATION_FAILED]: 'vox-chip vox-chip_bright-crimson-text',
    [DID_STATUS.ONGOING_PORTABILITY]: 'vox-chip vox-chip_aquamarine-text',
    [DID_STATUS.SCHEDULED_DELETION]:'vox-chip vox-chip_peach-text',
    [DID_STATUS.UNDER_TESTING]:'vox-chip vox-chip_gold-text'
  };
  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.statusClass = this.classMapping[this.status];
    this.status = this.status.replace(/#|_/g, ' ') as DID_STATUS;
  }

}
